<template>
    <DModal
        :title="__('settings.tax_exemptions.possible_tax_exemptions.title')"
        :message="__('settings.tax_exemptions.possible_tax_exemptions.message', {taxExemptions: taxExemptions})"
        :show="showModal"
        @confirm="$emit('confirm-modal')"
        @close="$emit('close-modal')"
    >
        <template #actions>
            <DButton
                :label="__('messages.save_anyway')"
                color="danger"
                @click="$emit('confirm-modal')"
            />
            <DButton
                :label="__('messages.back')"
                color="secondary"
                @click="$emit('close-modal')"
            />
        </template>
    </DModal>
</template>

<script>
export default {
    name: 'PossibleTaxExemptions',
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        taxExemptions: {
            type: String,
            default: ''
        }
    },
    emits: ['confirm-modal', 'close-modal']
}
</script>

<style scoped>

</style>
